<template>
  <tr>
    <td>{{ bookingUnassigned.customer_name }} <br/> <span style="font-size: 0.8rem;">({{bookingUnassigned.integration}})</span> </td>
    <td>
      {{ bookingUnassigned.trekksoft_booking_id }} 
      <br/> 
      <span style="font-size: 0.8rem;">({{bookingUnassigned.id}})</span>
      <span v-if="bookingUnassigned.trekksoft_remarks !== '' && bookingUnassigned.trekksoft_remarks !== null">
        <br/>
        <i class="fa fa-fw fa-2x fa-exclamation-triangle text-warning" title="Esta reserva tiene notas"></i>
        <button v-b-modal="'show_' + bookingUnassigned.id" class="mx-1 border" :variant="'light'">Ver notas</button>
      </span>
    </td>
    <td>
      <span>{{bookingUnassigned.trekksoft_activity_name}}</span> <br/> <span style="margin-left: 10px; color: #777;">({{ bookingUnassigned.trekksoft_availability_item_name }})</span>
    </td>
    <td>
      <span style="text-transform: uppercase">
        {{ bookingUnassigned.customer_language }}
        <country-flag
          v-if="bookingUnassigned.customer_language != 'otro'"
          :country="bookingUnassigned.customer_language"
          size="small"
        />
        <span v-else>?</span>
      </span>
    </td>
    <td>{{ bookingUnassigned.customer_adults }}</td>
    <td>{{ bookingUnassigned.customer_children }}</td>
    <td>
      {{
        bookingUnassigned.customer_adults +
        bookingUnassigned.customer_children
      }}
    </td>
    <td>
      {{ bookingUnassigned.agency }} 
      <br> 
      <span style="font-size: 0.8rem;">({{bookingUnassigned.channel}}) </span>
    </td>
    <td>{{ bookingUnassigned.trekksoft_hotel_name }}</td>
    <!-- <td>{{ bookingUnassigned.trekksoft_hotel_room }}</td> -->
    <td>
      <b-form-select v-model="bookingUnassigned.value">
        <optgroup label="Paradas cercanas al hotel">
          <option
            v-for="stop in nearbyStops(bookingUnassigned)"
            :key="stop.id"
            :label="stop.geo_point.name"
            :value="stop.id"
          >
            {{stop.geo_point.name}}
          </option>
        </optgroup>
        <!-- .sort((a,b) => a.geo_point.name.toLowerCase() > b.geo_point.name.toLowerCase() ? 1: -1) -->
        <optgroup label="Todas las paradas">
          <option
            v-for="stop in stops"
            :key="stop.id"
            :label="stop.geo_point.name"
            :value="stop.id"
          >
            {{stop.geo_point.name}}
          </option>
        </optgroup>
      </b-form-select>
    </td>
    <td>
      {{ bookingUnassigned.pickup_point_trekk }} 
      <br> 
      <span style="font-size: 0.8rem;">
        (Time: {{ bookingUnassigned.pickup_hour_trekk  || '?' }})
      </span>
    </td>
    <td>
      <booking-checks-cell :booking="bookingUnassigned" />
    </td>
    <td class="flex flex-row align-content-center align-items-center align-self-center flex-center">
      <b-button
        :variant="
          bookingUnassigned.value == undefined ? 'light' : 'dark'
        "
        :disabled="
          bookingUnassigned.value != undefined ? false : true
        "
        :title="
          bookingUnassigned.value == undefined
            ? 'Debe elegir una opción'
            : 'Assignar'
        "
        @click="
          assignStop(bookingUnassigned.id, bookingUnassigned.value)
        "
        class="border"
        >
          Asignar
        </b-button>
        <show-complete-booking-modal :bookingId="bookingUnassigned.id" />

        <booking-dropdown-bus-services :booking="bookingUnassigned" />
        
    </td>
  </tr>
            

    
</template>

<script>
/* eslint-disable */
import Spinner from "vue-spinner/src/ScaleLoader.vue";
import ShowCompleteBookingModal from "../Modal/ShowCompleteBookingModal";
import { mapGetters } from "vuex";
import BookingChecksCell from '../BookingCard/BookingChecksCell.vue';
import BookingDropdownBusServices from '../BookingCard/BookingDropdownBusServices.vue';

export default {
  components: {
    Spinner,
    ShowCompleteBookingModal,
    BookingChecksCell,
    BookingDropdownBusServices
  },
  props: {
    bookingUnassigned: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      
    };
  },
  computed: {
    ...mapGetters(["bookingsUnassigned"]),
    ...mapGetters(["stops"]),
    ...mapGetters(['groups', 'groupsListAdmin', 'groups']),
    ...mapGetters(['activeTab']),
    ...mapGetters(['activeOption']),
  },
  async mounted() {
    const stopFilter = {
      activity_group: this.$store.getters.filterGroup,
    };
    //await this.$store.dispatch("stops/loadStops", stopFilter);
    
  },
  methods: {
    async assignStop(bookingId, stopId) {
      if (stopId == "") return;

      const payload = {
        id: bookingId,
        data: {
          stop_schedule: stopId,
        },
      };

      await this.$store.dispatch("bookingsBus/assignStop", payload);
      this.$notify({
        group: "foo",
        title: "Reserva asignada",
        text: `Se han asignado la reserva ${bookingId} a la parada indicada`,
        type: "success",
      });

      
    },
    nearbyStops(bookingUnassigned) {
      // return stops that are in the same subzone as hotel name
      let list = [];
      for (let stop in this.stops) {
        if (bookingUnassigned.subzone_by_hotel != null) {
          if (
            this.stops[stop].geo_point.sub_zone ==
            bookingUnassigned.subzone_by_hotel.sub_zone
          ) {
            list.push(this.stops[stop]);
          }
        }
      }
      return list;
    },
    async toggleBusService(id, service) {
      const payload = {
        id: id,
        service: service
      }
      await this.$store.dispatch("bookings/toggleBusService", payload)
    }
  },
};
</script>


<style scoped>
#checks_column i, #stop_column i {
  font-size: 14px;
  margin-left: 2px;
}
</style>